import { OuterRow, SmallTitle } from "pages/setting/components/Layout.styled";

export const SettingSection = ({ sectionName, children }) => {
  return (
    <OuterRow>
      <SmallTitle style={{ flexBasis: "130px" }}>{sectionName}</SmallTitle>
      {children}
    </OuterRow>
  );
};
